import {useState} from 'react'

import {SelectOption} from '../../../models/utility.model'
import useMasterListService from '../../central/hooks/useMasterService'

const useTableForMaster = () => {
  const [bedClotheOperation, setBedClotheOperation] = useState<SelectOption[]>([])
  const [deliveryLocation, setDeliveryLocation] = useState<SelectOption[]>([])
  const [frecuency, setFrecuency] = useState<SelectOption[]>([])
  const [inspectionScope, setInspectionScope] = useState<SelectOption[]>([])
  const [nivel, setNivel] = useState<SelectOption[]>([])
  const [originLaundry, setOriginLaundry] = useState<SelectOption[]>([])
  const [statusUser, setStatusUser] = useState<SelectOption[]>([])
  const [statusOperational, setStatusOperational] = useState<SelectOption[]>([])
  const [statusService, setStatusService] = useState<SelectOption[]>([])
  const [statusLaundry, setStatusLaundry] = useState<SelectOption[]>([])
  const [statusLaundryLot, setStatusLaundryLote] = useState<SelectOption[]>([])
  const [typeAdmin, setTypeAdmin] = useState<SelectOption[]>([])
  const [typeClothe, setTypeClothe] = useState<SelectOption[]>([])
  const [typeInspect, setTypeInspect] = useState<SelectOption[]>([])
  const [typeLaundryOrderLote, setTypeLaundryOrderLote] = useState<SelectOption[]>([])
  const [typeLaundryOrder, setTypeLaundryOrder] = useState<SelectOption[]>([])
  const [typeReception, setTypeReception] = useState<SelectOption[]>([])
  const [typeResponsableOrder, setTypeResponsableOrder] = useState<SelectOption[]>([])
  const [typeProcessLaundry, setTypeProcessLaundry] = useState<SelectOption[]>([])
  const [washingPlace, setWashingPlace] = useState<SelectOption[]>([])
  const [typeGuest, setTypeGuest] = useState<SelectOption[]>([])
  const [typeGuestStay, setTypeGuestStay] = useState<SelectOption[]>([])
  const [typeConfig, setTypeConfig] = useState<SelectOption[]>([])
  const [typeLaundryOrderLN, setTypeLaundryOrderLN] = useState<SelectOption[]>([])
  const [typeCodesSequence, setTypeCodesSequence] = useState<SelectOption[]>([])

  const {getMasterMappedData, getMasterData} = useMasterListService()
  const getBedClotheOperationList = async () => {
    try {
      const response = await getMasterMappedData('RopaCamaOperacion', 'nombreCorto')
      setBedClotheOperation(response)
    } catch (error) {
      setBedClotheOperation([])
    }
  }
  const getDeliveryLocationList = async () => {
    try {
      const response = await getMasterMappedData('LugarEntrega')
      setDeliveryLocation(response)
    } catch (error) {
      setDeliveryLocation([])
    }
  }
  const getInspectionScopeList = async () => {
    try {
      const response = await getMasterMappedData('AlcanceInspeccion')
      setInspectionScope(response)
    } catch (error) {
      setInspectionScope([])
    }
  }
  const getNivelList = async () => {
    try {
      const response = await getMasterMappedData('Nivel', 'id')
      setNivel(response)
    } catch (error) {
      setNivel([])
    }
  }
  const getOriginLaundryList = async () => {
    try {
      const response = await getMasterMappedData('OrigenLavanderia', 'nombreCorto')
      setOriginLaundry(response)
    } catch (error) {
      setOriginLaundry([])
    }
  }
  const getFrecuencyList = async () => {
    try {
      const response = await getMasterMappedData('FrecuenciaMantenimiento')
      setFrecuency(response)
    } catch (error) {
      setFrecuency([])
    }
  }
  const getResponsaleOrderList = async () => {
    try {
      const response = await getMasterMappedData('ResponsableOrden')
      return response || []
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getStatusLaundryList = async () => {
    try {
      const response = await getMasterMappedData('EstadoLavanderia')
      setStatusLaundry(response)
    } catch (error) {
      setStatusLaundry([])
    }
  }
  const getStatusLaundryLotList = async () => {
    try {
      const response = await getMasterMappedData('ESTADOORDENLOTE')
      setStatusLaundryLote(response)
    } catch (error) {
      setStatusLaundryLote([])
    }
  }
  const getStatusOperationalList = async () => {
    try {
      const response = await getMasterMappedData('EstadoOperatividad')
      setStatusOperational(response)
    } catch (error) {
      setStatusOperational([])
    }
  }
  const getStatusUserList = async () => {
    try {
      const response = await getMasterMappedData('EstadoUsuario')
      setStatusUser(response)
    } catch (error) {
      setStatusUser([])
    }
  }

  const getStatusServiceList = async () => {
    try {
      const response = await getMasterMappedData('EstadoServicio')
      setStatusService(response)
    } catch (error) {
      setStatusService([])
    }
  }
  const getTypeAdminList = async () => {
    try {
      const response = await getMasterMappedData('TipoAdministracion')
      setTypeAdmin(response)
    } catch (error) {
      setTypeAdmin([])
    }
  }
  const getTypeClotheList = async () => {
    try {
      const response = await getMasterMappedData('TipoRopa')
      setTypeClothe(response)
    } catch (error) {
      setTypeClothe([])
    }
  }
  const getTypeInspectList = async () => {
    try {
      const response = await getMasterMappedData('TipoInspeccion')
      setTypeInspect(response)
    } catch (error) {
      setTypeInspect([])
    }
  }
  const getTypeLaundryLoteList = async () => {
    try {
      const response = await getMasterMappedData('TIPOLAVADO')
      setTypeLaundryOrderLote(response)
    } catch (error) {
      setTypeLaundryOrderLote([])
    }
  }
  const getTypeLaundryOrderList = async () => {
    try {
      const response = await getMasterMappedData('TIPOORDENLAVADO')
      setTypeLaundryOrder(response)
    } catch (error) {
      setTypeLaundryOrder([])
    }
  }
  const getTypeLaundryOrderListLongName = async () => {
    try {
      const response = await getMasterMappedData('TIPOORDENLAVADO', 'codigo', 'nombreLargo')
      setTypeLaundryOrderLN(response)
    } catch (error) {
      setTypeLaundryOrderLN([])
    }
  }
  const getTypeReceptionList = async () => {
    try {
      const response = await getMasterMappedData('TipoRecepcion')
      setTypeReception(response)
    } catch (error) {
      setTypeReception([])
    }
  }
  const getTypeProcessLaundryList = async () => {
    try {
      const response = await getMasterMappedData('TIPOPROCESO')
      setTypeProcessLaundry(response)
    } catch (error) {
      setTypeProcessLaundry([])
    }
  }
  const getTypeResponsableOrderList = async () => {
    try {
      const response = await getMasterMappedData('ResponsableOrden')
      setTypeResponsableOrder(response)
    } catch (error) {
      setTypeResponsableOrder([])
    }
  }
  const getWashingPlaceList = async () => {
    try {
      const response = await getMasterMappedData('LugarLavadoLavanderia')
      setWashingPlace(response)
    } catch (error) {
      setWashingPlace([])
    }
  }
  const getTypeGuestList = async () => {
    try {
      const response = await getMasterMappedData('TipoHuesped')
      setTypeGuest(response)
    } catch (error) {
      setTypeGuest([])
    }
  }
  const getTypeGuestStayList = async () => {
    try {
      const response = await getMasterMappedData('TipoEstadiaHuesped')
      setTypeGuestStay(response)
    } catch (error) {
      setTypeGuestStay([])
    }
  }

  const getTypeConfigList = async () => {
    try {
      const response = await getMasterMappedData('TIPOCONFIGURACION')
      setTypeConfig(response)
    } catch (error) {
      setTypeConfig([])
    }
  }

  const getCodesSequencenList = async () => {
    try {
      const response = await getMasterData('LAVTIPOCOD')
      const mapped = response.map((item) => ({value: item.id, label: item.nombreLargo, ...item}))
      setTypeCodesSequence(mapped)
    } catch (error) {
      setTypeCodesSequence([])
    }
  }

  return {
    setTypeProcessLaundry,
    bedClotheOperation,
    deliveryLocation,
    frecuency,
    inspectionScope,
    nivel,
    originLaundry,
    statusOperational,
    statusLaundry,
    statusLaundryLot,
    statusUser,
    statusService,
    typeAdmin,
    typeClothe,
    typeInspect,
    typeLaundryOrder,
    typeReception,
    typeResponsableOrder,
    typeProcessLaundry,
    washingPlace,
    typeGuest,
    typeGuestStay,
    typeConfig,
    typeLaundryOrderLote,
    typeLaundryOrderLN,
    typeCodesSequence,
    getBedClotheOperationList,
    getDeliveryLocationList,
    getFrecuencyList,
    getInspectionScopeList,
    getNivelList,
    getOriginLaundryList,
    getResponsaleOrderList,
    getStatusLaundryList,
    getStatusOperationalList,
    getStatusUserList,
    getStatusServiceList,
    getTypeAdminList,
    getTypeClotheList,
    getTypeInspectList,
    getTypeLaundryOrderList,
    getTypeReceptionList,
    getTypeResponsableOrderList,
    getTypeProcessLaundryList,
    getWashingPlaceList,
    getTypeGuestList,
    getTypeGuestStayList,
    getStatusLaundryLotList,
    getTypeConfigList,
    getTypeLaundryLoteList,
    getTypeLaundryOrderListLongName,
    getCodesSequencenList,
  }
}

export default useTableForMaster
